import { SelectProps } from "antd/lib";

/** Столько опций ещё умещаются в выпадающий список без поиска. */
const SEARCH_THRESHOLD = 5;

/**
 * Поиск по опциям включается сам, когда их больше `SEARCH_THRESHOLD`, и ищет по подписи (`label`),
 * а не по `value`, как делает antd по умолчанию. Явные `showSearch` и `optionFilterProp`
 * из пропсов имеют приоритет.
 */
export function useAutoSearch({
  options,
  showSearch,
  optionFilterProp,
}: SelectProps) {
  return {
    showSearch: showSearch ?? countOptions(options) > SEARCH_THRESHOLD,
    optionFilterProp: optionFilterProp ?? "label",
  };
}

function countOptions(options: SelectProps["options"] = []): number {
  return options.reduce<number>((count, option) => {
    const nested: unknown = option.options;

    return count + (Array.isArray(nested) ? countOptions(nested) : 1);
  }, 0);
}
